import { TableUI } from "components/design/TableUI";
import { useMemo, useState } from "react";
import {
  getCoreRowModel,
  RowSelectionState,
  useReactTable,
} from "react-table-8.10.7";
import { VendorBill } from "types/Models/vendorBills";
import { billColumns } from "./BillList";

export const BillTable = ({
  billsData,
  onRowClick,
  disabledRowIds = [],
  showActionsColumn = true,
  rowSelection = {},
  setRowSelection,
}: {
  billsData: VendorBill[];
  onRowClick?: (uuid: string, status: string) => () => void;
  disabledRowIds?: string[];
  showActionsColumn?: boolean;
  rowSelection?: RowSelectionState;
  setRowSelection?: (
    updaterOrValue:
      | RowSelectionState
      | ((prev: RowSelectionState) => RowSelectionState)
  ) => void;
}) => {
  const disabledRows = billsData
    .filter((bill) => bill.bill_payment_status !== "DRAFT")
    .map((bill) => bill.uuid);

  const [sorting, setSorting] = useState<
    {
      desc: boolean;
      id: "CREATED_AT" | "SENT_TO" | "AMOUNT";
    }[]
  >([]);

  const baseColumns = [
    billColumns.bill_select(),
    billColumns.bill_number(),
    billColumns.entity_merchant_data(),
    billColumns.due_balance(),
    billColumns.bill_date(),
    billColumns.due_date(),
    billColumns.bill_request_status(),
    billColumns.source(),
  ];

  const data = useMemo(() => billsData || [], [billsData]);
  const [displayCurrency, setDisplayCurrency] = useState<
    "INVOICE_CURRENCY" | "USD"
  >("INVOICE_CURRENCY");

  const table = useReactTable({
    data,
    columns: baseColumns,
    getCoreRowModel: getCoreRowModel(),
    defaultColumn: {
      minSize: 5,
    },
    onRowSelectionChange: setRowSelection,
    state: {
      sorting,
      rowSelection,
      columnVisibility: {
        Actions: showActionsColumn,
      },
    },
    manualSorting: true,
    enableMultiSort: false,
    enableSortingRemoval: false,
    getRowId: (row) => row.uuid,
    // @ts-ignore
    onSortingChange: setSorting,
    meta: {
      displayCurrency,
      setDisplayCurrency,
      disabledRows: disabledRowIds,
    },
    enableRowSelection: (row) => !disabledRowIds.includes(row.id),
  });

  return (
    <>
      <TableUI
        table={table}
        onRowClick={(row) =>
          onRowClick?.(row.original.uuid, row.original.state)
        }
        disabledRows={disabledRowIds}
      />
    </>
  );
};
